class Item {
	constructor(config) {
		this.config = Object.assign({
			scope: '.service-details-wrapper',
			slider: '.project-detail-slider'
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.addSlider();
	}

	addSlider() {
		let $slider = this.$scope.find(this.config.slider);
		$slider.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: false,
			arrows: true,
			prevArrow: $slider.closest(this.config.scope).find('.custom-slick-carousel-nav-prev'),
			nextArrow: $slider.closest(this.config.scope).find('.custom-slick-carousel-nav-next'),
			infinite: false,
		});
	}
}

export default new Item;